
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M8.005 9.631l-5.89 6a1.222 1.222 0 01-1.752-.001 1.28 1.28 0 010-1.787l5.732-5.838L.363 2.156a1.28 1.28 0 010-1.786 1.222 1.222 0 011.753 0l5.879 6 5.89-6a1.222 1.222 0 011.752.001 1.28 1.28 0 010 1.787L9.905 7.995l5.732 5.849a1.28 1.28 0 010 1.786 1.222 1.222 0 01-1.753 0l-5.879-6z"}})]),_c('path',{attrs:{"fill-rule":"evenodd","d":"M1.758 15.28l6.247-6.363 6.236 6.363a.723.723 0 001.039 0 .78.78 0 000-1.086l-6.076-6.2 6.076-6.188a.78.78 0 000-1.086.723.723 0 00-1.038 0L7.995 7.083 1.759.72A.723.723 0 00.72.72a.78.78 0 000 1.086l6.076 6.2L.72 14.193a.78.78 0 000 1.086.723.723 0 001.038 0z"}})])
          )
        }
      }
    